'use client';

import { Typography } from '@mui/material';
import { createContext, Fragment, useContext } from 'react';
import type { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { StructuredContentRenderer } from '../..';

export type TypeProps = StructuredContentDocument<{
  bold?: boolean;
  children: StructuredContentDocument;
  italic?: boolean;
}>;

const TypeContext = createContext(false);

export const Type = ({ props }: TypeProps) => {
  const nested = useContext(TypeContext);
  let tag: React.ElementType = nested ? 'span' : 'p';
  if (props.bold) {
    tag = 'strong';
  }

  return (
    <TypeContext.Provider value={true}>
      <Typography
        component={tag}
        style={{ whiteSpace: 'pre-line' }}
        sx={{
          fontWeight: props.bold ? '700 !important' : 'inherit',
          fontStyle: props.italic ? 'italic' : undefined,
          fontSize: props.bold ? 'inherit' : 'initial',
        }}
      >
        {[props.children].flat().map((child, idx) => {
          if (typeof child === 'string') {
            if (child === '\n') {
              return <br key={idx} />;
            }
            return <Fragment key={idx}>{child}</Fragment>;
          }

          if (child) {
            return <StructuredContentRenderer doc={child} key={idx} />;
          }
        })}
      </Typography>
    </TypeContext.Provider>
  );
};
